import ArticlesPreviews from './ArticlesPreviews';

export default ArticlesPreviews;
